import { useFormContext } from 'react-hook-form';
import FormDropdown from '../FormDropdown/FormDropdown';
import { FormFieldProps } from '../FormField/FormField';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { OTHERFAVORITEPLAYER_IDENTIFIER, OTHEROPTION, FAVORITEPLAYER, MENCATEGORY, WOMENCATEGORY } from '@r-and-a-shared-ui/utils';
import { FormTextInput } from '../FormTextInput/FormTextInput';

export const enum PlayerGender {
  Men = 'Men',
  Women = 'Women'
}

export function FavoritePlayerFormField(props: FormFieldProps) {
  const { watch, setValue, formState: { errors } } = useFormContext();
  const { name: categoryFieldName } = props;

  const favoritePlayerField = props.subfields?.find((field) =>
    field?.name?.includes(FAVORITEPLAYER)
  ) as FormFieldProps | undefined;

  const playersList = useMemo(() => {
    return favoritePlayerField?.options || [];
  }, [favoritePlayerField?.options]);

  const selectedFavoritePlayer = favoritePlayerField?.name ? watch(favoritePlayerField.name)?.value ?? watch(favoritePlayerField.name) : undefined;
  
  const favoritePlayerOtherField = props.subfields?.find((field) =>
    field?.name?.includes(OTHERFAVORITEPLAYER_IDENTIFIER)
  ) as FormFieldProps | undefined;

  const [filteredPlayers, setFilteredPlayers] = useState<FormFieldProps['options']>([]);
  const categorySelected = categoryFieldName ? watch(categoryFieldName)?.value ?? watch(categoryFieldName) : '';

  const onGenderClear = () => {
    setValue(favoritePlayerField?.name ?? '', '');
  }

  useEffect(() => {
    if (categorySelected && categorySelected !== OTHEROPTION) {
      const gender = categorySelected === MENCATEGORY ? PlayerGender.Men : PlayerGender.Women;
      const playersListFiltered = playersList.filter(player => player.gender === gender)
      if (selectedFavoritePlayer === OTHEROPTION || !playersListFiltered.find(player => player.value === selectedFavoritePlayer)) {
        setValue(favoritePlayerField?.name ?? '', '');
      }
      setFilteredPlayers(playersListFiltered);
    }
  }, [categorySelected, playersList, favoritePlayerField?.name, favoritePlayerOtherField?.name, setValue]);

  useEffect(() => {
    if (!favoritePlayerField?.name || !favoritePlayerOtherField?.name) return;

    if (selectedFavoritePlayer !== OTHEROPTION) {
      setValue(favoritePlayerOtherField.name, ''); 
    }
  }, [favoritePlayerField?.name, favoritePlayerOtherField?.name, selectedFavoritePlayer, setValue, watch]);
  
  useEffect(() => {
    if (!categorySelected && !selectedFavoritePlayer) {
      setValue(favoritePlayerField?.name ?? '', '');
      setValue(categoryFieldName, '');
  
      if (favoritePlayerOtherField?.name) {
        setValue(favoritePlayerOtherField.name, '');
      }
    }
  }, [categorySelected, selectedFavoritePlayer, setValue, favoritePlayerField?.name, categoryFieldName, favoritePlayerOtherField?.name]);
  
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (selectedFavoritePlayer && !categorySelected && isFirstRender.current) {
      const foundPlayer = playersList.find(player => player.value === selectedFavoritePlayer);
  
      if (foundPlayer) {
        const correctCategory = foundPlayer.gender === PlayerGender.Men ? MENCATEGORY : WOMENCATEGORY;
  
        if (selectedFavoritePlayer !== OTHEROPTION && categorySelected !== correctCategory) {
          setValue(categoryFieldName, correctCategory);
        } else if (selectedFavoritePlayer === OTHEROPTION) {
          setValue(categoryFieldName, OTHEROPTION);
        }
      }
    }
  
    isFirstRender.current = false;
  }, [selectedFavoritePlayer, playersList, setValue, categoryFieldName, categorySelected, watch]);
  

  return (
    <>
      <FormDropdown {...props} entireObjectSelection menuPlacement="bottom" onClear={onGenderClear} />
      {favoritePlayerField && categorySelected && (categorySelected !== OTHEROPTION) && (
        <FormDropdown
          {...favoritePlayerField}
          key={favoritePlayerField.name}
          options={filteredPlayers}
          entireObjectSelection
          menuPlacement="bottom"
          triggerError={!!errors?.[favoritePlayerField?.name]}
        />
      )}
      {favoritePlayerOtherField && 
      favoritePlayerField?.name && 
      selectedFavoritePlayer === OTHEROPTION && 
      (categorySelected || watch(favoritePlayerOtherField.name)) && (
        <FormTextInput
          {...favoritePlayerOtherField}
          key={favoritePlayerOtherField.name}
          value={watch(favoritePlayerOtherField.name) || ''}
          onChange={(e) => setValue(favoritePlayerOtherField.name, e.target.value)}
          triggerError={!!errors?.[favoritePlayerOtherField.name]}
        />
      )}
    </>
  );
}

export default FavoritePlayerFormField;
